import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useTenant } from "./useTenant";

export interface MentionableUser {
  user_id: string;
  email: string;
  full_name: string;
}

export function useMentionableUsers() {
  const { tenantId, tenantReady } = useTenant();

  return useQuery({
    queryKey: ["mentionable-users", tenantId],
    enabled: tenantReady && !!tenantId,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_mentionable_users_for_tenant",
        { _tenant_id: tenantId! },
      );
      if (error) throw error;
      return (data ?? []) as MentionableUser[];
    },
  });
}

/** Display label for a user in the mention picker / rendered note. */
export function mentionLabel(u: MentionableUser): string {
  return u.full_name?.trim() || u.email.split("@")[0] || u.email;
}